import React from 'react';
import Background from "../../assets/images/background/banner.jpg";
import "./term.css";
import { Link } from 'react-router-dom';
import SEO from '../seo';


export default function Refund() {
    
       const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    return (
        <div>
               <SEO
                title="Refund"
                description="Refund Policy @ HWPL! This Refund Policy applies to all products and services provided by us. Refund And Cancellation Policy We understand, however, that exceptional circumstance may occur due to the nature of the services we supply, so please, get acquainted with our Refund Policy before you order our software services to avoid dissatisfaction after [&hellip;]"
                canonical="https://www.hwplindia.com/refund/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2024/01/erp-crm-development-company-banner-img.png"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Refund</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Refund</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section term-section">
                <div className="term-container">
                    {/* Content */}
                    <section className="cta-section term-content">
                        <h3 className='underline-red'>Refund Policy @ HWPL!</h3>
                        <p className='email'>
                           This Refund Policy applies to all products and services provided by us.
                        </p>
                    </section>

                    <section className="cta-section term-content">
                        <h3 className='underline-red'>Refund And Cancellation Policy</h3>
                        <p className='email'>
                           We understand, however, that exceptional circumstance may occur due to the nature of the services we supply, so please, get acquainted with our Refund Policy before you order our software services to avoid dissatisfaction after the purchase.
                        </p>
                        <p className='email'>
                            You have the unconditional right to claim and receive a full refund for the software services within 14 days following the day of your purchase.
                        </p>
                        <p className='email'>
                            Since all of our services are intangible irrevocable goods ( software services), served instantly once payment is received, they come with a 14-Day Money-Back Guarantee means we will be glad to return your investment if we are sure that the service is malfunctioning (i.e. doesn’t function according to the features as described) on a client’s computer/mobile device.
                        </p>
                        <p className='email'>
                            If you are not 100% satisfied with any infolink software services, please contact us within 14 days of your purchase to receive a refund.
                        </p>
                        <p className='email'>
                            Requests for refunds must be:
                        </p>
                        <p className='email'>
                            Made within fourteen (14) days of the purchase date.
                        </p>
                        <p className='email'>
                           Upon sending a refund request, please allow our Customer Service Team up to one (1) business day to get back to you on the problem.
                        </p>
                        <p className='email'>
                            You should expect an email from our company.
                        </p>
                        <p className='email'>
                            If a refund is approved, it might take us up to 7-10 business day to process it. You will get the money returned in the same form of currency used for the purchase and it should appear on your debit card,credit card,prepaid debit card,gift card or Paypal statement within 7-10 business days upon us notifying you.
                        </p>
                        <p className='email'>
                           The refund will be issued to the customer in full without any compensations or additional reimbursements.
                        </p>
                        <p className='email'>
                           No refund will be available after refund period(14 days) is over. Once Project start & content is deliver to client so no payment will be refundable in any circumstances.
                        </p>
                        <p className='email'>
                            Our focus is complete customer satisfaction. In the event, if you are displeased with the services provided, we will refund back the money, provided the reasons are genuine and proved after investigation. Please read the fine prints of each deal before buying it, it provides all the details about the services or the product you purchase.
                        </p>
                        <p className='email'>
                            In case of dissatisfaction from our services, clients have the liberty to cancel their projects and request a refund from us. Our Policy for the cancellation and refund will be as follows:
                        </p>
                    </section>

                    <section className="cta-section term-content">
                        <h3 className='underline-red'>Cancellation Policy</h3>
                        <p className='email'>
                            For Cancellations please contact the us via contact us link.
                        </p>
                        <p className='email'>
                            Requests received later than 5 business days prior to the end of the current service period will be treated as cancellation of services for the next service period.
                        </p>
                    </section>

                    <section className="cta-section term-content">
                        <h3 className='underline-red'>Refund Policy</h3>
                        <p className='email'>
                            We will try our best to create the suitable design concepts for our clients.
                        </p>
                        <p className='email'>
                            The Buyer shall pay the price of the Goods on the payment date started in the Contract or if no In case any client is not completely satisfied with our products we can provide a refund.
                        </p>
                        <p className='email'>
                            If paid by credit card, refunds will be issued to the original credit card provided at the time of purchase and in case of payment gateway name payments refund will be made to the same account.
                        </p>
                    </section>
                </div>
            </section>
        </div>
    );
}